import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import { navLinks } from '../UseMemberAdministration';

import useMemberAdministrationFoundationBoardData from '@usas/ui-web/state/memberAdministration/foundationBoard/UseMemberAdministrationFoundationBoardData';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';

const useFoundationBoardMembers = () => {
  const navigate = useNavigate();
  const { 
    memberAdministrationFoundationBoardState, 
    getFoundationBoardDirectors, 
    deleteFoundationBoardDirector, 
    confirmSave } = useMemberAdministrationFoundationBoardData();

  const [viewState, setViewState] = useState(getInitialViewState);
  const [gridState, setGridState] = useState([]);

  const onAddBoardMember = () => {
    navigate(navLinks.FOUNDATION_BOARD_ADD);
  };

  const onEditBoardMember = (personId, personOrgRoleDurationId) => {
    navigate(navLinks.FOUNDATION_BOARD_EDIT, { state: { personId, personOrgRoleDurationId } });
  };

  const onDeleteBoardMember = (e, personOrgRoleDurationId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    deleteFoundationBoardDirector(personOrgRoleDurationId);
  };

  const onFilterCurrentMembers = () => {
    if (memberAdministrationFoundationBoardState.isArrayLoading === false) {
      setViewState({
        ...viewState,
        toggleCurrentStaffRoles: !viewState.toggleCurrentStaffRoles
      });
      setGridState(filterBoardMembersForGrid(memberAdministrationFoundationBoardState.arrayData, !viewState.toggleCurrentStaffRoles));
    }
  };

  useEffect(() => {
    if (memberAdministrationFoundationBoardState.isSaved === true) {
      confirmSave();
    } else {
      getFoundationBoardDirectors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberAdministrationFoundationBoardState.isSaved]);

  useEffect(() => {
    if (memberAdministrationFoundationBoardState.isArrayLoading === false && memberAdministrationFoundationBoardState.isArrayLoaded === true) {
      setGridState(filterBoardMembersForGrid(memberAdministrationFoundationBoardState.arrayData, viewState.toggleCurrentStaffRoles));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberAdministrationFoundationBoardState]);

  function filterBoardMembersForGrid(arrayData, toggleCurrentStaffRoles = false) {
    const today = new Date();
    const gridData = [];

    for (const staff of arrayData) {
      const roleDurations = [];

      if (Array.isArray(staff.orgRoles) && staff.orgRoles.length > 0) {
        if (toggleCurrentStaffRoles === true) {
          for (const duration of staff.orgRoles) {
            if (duration.isCurrent === true) {
              roleDurations.push({
                personOrgRoleDurationId: duration.personOrgRoleDurationId || Constants.DEFAULT_ID,
                personOrgRoleId: duration.personOrgRoleId || Constants.DEFAULT_ID,
                effectiveDate: duration.effectiveDate ? formatDate(duration.effectiveDate) : '',
                expirationDate: duration.expirationDate ? formatDate(duration.expirationDate) : '',
                isCurrent: duration.isCurrent === true ? true : false,
                canDelete: new Date(duration.expirationDate) > today ? true : false,
                orgRoleId: duration.orgRoleId || '',
                orgRoleName: duration.orgRoleName || ''
              });
            }
          }
        } else {
          for (const duration of staff.orgRoles) {
            roleDurations.push({
              personOrgRoleDurationId: duration.personOrgRoleDurationId || Constants.DEFAULT_ID,
              personOrgRoleId: duration.personOrgRoleId || Constants.DEFAULT_ID,
              effectiveDate: duration.effectiveDate ? formatDate(duration.effectiveDate) : '',
              expirationDate: duration.expirationDate ? formatDate(duration.expirationDate) : '',
              isCurrent: duration.isCurrent === true ? true : false,
              canDelete: new Date(duration.expirationDate) > today ? true : false,
              orgRoleId: duration.orgRoleId || '',
              orgRoleName: duration.orgRoleName || ''
            });
          }
        }
      }

      if (roleDurations.length > 0) {
        roleDurations.sort((a, b) => new Date(b.expirationDate) - new Date(a.expirationDate));

        gridData.push({
          personId: staff.personId || '',
          name: `${staff.firstName || ''} ${staff.lastName || ''}`,
          email: staff.email || '',
          roleDurations
        });
      }
    }

    return gridData;
  };

  function getInitialViewState() {
    return {
      toggleCurrentStaffRoles: true
    };
  };

  return {
    isSaving: memberAdministrationFoundationBoardState.isSaving,
    isGridLoading: memberAdministrationFoundationBoardState.isArrayLoading,
    viewState,
    gridState,
    onFilterCurrentMembers,
    onEditBoardMember,
    onAddBoardMember,
    onDeleteBoardMember
  };
};

export default useFoundationBoardMembers;